import { libreBaskerville as editorial } from '@/fonts'
import { Search } from './search'
import styles from './templates.module.css'

export function Banner({
  title = 'A starting point for every idea.',
  description = 'Find a form for your next survey, registration, or conversation. Make it yours with HeyForm.',
  keyword = ''
}: {
  title?: string
  description?: string
  keyword?: string
}): JSX.Element {
  return (
    <header className={styles.banner}>
      <div className={styles.container}>
        <h1 className={`${styles.title} ${editorial.className}`}>{title}</h1>
        <p className={styles.description}>{description}</p>
        <Search initialValue={keyword} />
      </div>
    </header>
  )
}
